import React, { SVGProps } from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface FireIconProps extends SVGProps<SVGSVGElement> {
  width?: string;
  height?: number;
}
const FireIcon: React.FC<FireIconProps> = ({
  width = 16,
  height = 16,
  ...props
}) => {
  return (
    <SVGUniqueID>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 16 16"
      >
        <path
          fill="#F3705A"
          d="M4.392 14.554c-.734-.834-1.468-1.702-1.936-2.737a6.206 6.206 0 01-.367-3.572A7.704 7.704 0 013.625 4.94a3.184 3.184 0 00.8 2.337c-.333-1.602.201-3.338 1.27-4.606C6.762 1.402 8.23.567 9.766 0c-.768.801-.868 2.07-.568 3.138.3 1.068.935 2.003 1.502 2.97.568.969 1.102 1.97 1.135 3.072.3-.568.635-1.135.835-1.77.2-.634.3-1.301.134-1.936.6.735.934 1.47 1.101 2.404.167.935.134 1.903.034 2.837-.134 1.035-.401 2.103-.969 2.971-.667 1.035-1.735 1.77-2.904 2.17-2.07.367-4.106.067-5.675-1.302z"
        ></path>
        <path
          fill="#FFD15C"
          d="M6.93 15.788c2.737 1.069 5.441-2.17 3.939-4.673 0-.033-.033-.033-.033-.067.133 1.369-.2 2.37-.835 2.938.334-.801.1-1.736-.3-2.537-.4-.768-.968-1.469-1.402-2.203-.434-.768-.768-1.636-.568-2.504-.801.601-1.368 1.502-1.602 2.47-.234.968-.1 2.037.334 2.938-.501-.367-.868-.968-.902-1.602-.534.634-.867 1.468-.834 2.303 0 1.302 1.035 2.47 2.203 2.937z"
        ></path>
      </svg>
    </SVGUniqueID>
  );
};

export { FireIcon };
